import * as TabsPrimitive from '@radix-ui/react-tabs'
import { styled } from 'style'

export const StyledRoot = styled(TabsPrimitive.Root, {
  display: 'flex',
  flexDirection: 'column',
  width: '$full',

  // TODO: implement horizontal layout
  '&[data-orientation="horizontal"]': {},
})

export const StyledList = styled(TabsPrimitive.List, {
  display: 'flex',
  flexShrink: 0,
  spaceX: 6,
})

export const StyledTrigger = styled(TabsPrimitive.Trigger, {
  all: 'unset',
  userSelect: 'none',
  cursor: 'pointer',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 36,
  color: '$text2',
  fontSize: '$sm',
  fontWeight: '$medium',
  lineHeight: '$sm',
  borderBottom: '3px solid $transparent',

  transition: '.2s ease',

  '&[data-state="active"]': {
    color: '$text1',
    borderBottom: '3px solid $accent',
  },
})

export const StyledContent = styled(TabsPrimitive.Content, {
  outline: 'none',
})
